import "./style.scss";

const FLAG_SPRITE_PATH = "/images/icons/countryFlags/flags-sprite.svg"

const CountryFlagsComponent = (props) => {
    const { countryCode, class: className, size } = props;
    return (
        <svg className={className ?? ""} width={size ?? "34"} height={size ?? "34"}>
            <use href={`${FLAG_SPRITE_PATH}#${countryCode}`} />
        </svg>
    )
}

export default CountryFlagsComponent;